"use client";

import ReplyIcon from '@mui/icons-material/Reply';
import { Box, Button, Typography, List, ListItem, Divider, Link, ThemeProvider, createTheme } from "@mui/material";
import Wrapper from "/src/components/Wrapper.jsx";
import AppBar from "@mui/material/AppBar";
import Grid from "@mui/material/Grid";
import Image from "next/image";
import React from "react";
import CrispChat from "/src/components/CrispChat.jsx";
const tableOfContents = [{
  title: 'I. Descriptio Datenschutzerklärung',
  page: 2
}, {
  title: 'II. Erfassung personenbezogener Daten',
  page: 2
}, {
  title: 'a. Daten, die Sie uns wissentlich und freiwillig bereitstellen',
  page: 2
}, {
  title: 'b. Automatisch erfasste Daten',
  page: 3
}, {
  title: 'c. Anonymisierung und Zusammenfassung von Daten',
  page: 3
}, {
  title: 'd. Cookies und ähnliche Technologien',
  page: 3
}, {
  title: 'III. Hosting und Content Delivery Networks (CDN)',
  page: 4
}, {
  title: 'IV. Verwendung Ihrer personenbezogenen Daten',
  page: 5
}, {
  title: 'V. Rechtsgrundlagen für die Verarbeitung',
  page: 6
}, {
  title: 'VI. Weitergabe Ihrer personenbezogenen Daten',
  page: 6
}, {
  title: 'VII. Verkauf von persönlichen Informationen',
  page: 9
}, {
  title: 'VIII. Datenschutz für Minderjährige und Kinder',
  page: 9
}, {
  title: 'A. Schutz von Kindern im Internet',
  page: 9
}, {
  title: 'b. Löschung',
  page: 9
}, {
  title: 'IX. Links zu Diensten Dritter',
  page: 9
}, {
  title: 'X. Soziale Medienfunktionen und Widgets',
  page: 10
}, {
  title: 'XI. Sicherheit und Aufbewahrung Ihrer Daten',
  page: 10
}, {
  title: 'a. Sicherheit',
  page: 10
}, {
  title: 'b. Speicherung',
  page: 10
}, {
  title: 'c. Aufbewahrung',
  page: 10
}, {
  title: 'XII. Internationale Benutzer',
  page: 10
}, {
  title: 'a. Zustimmung zur Übertragung',
  page: 10
}, {
  title: 'XIII. Hinweis zur Datenweitergabe in die USA',
  page: 11
}, {
  title: 'XIV. Rechte der betroffenen Personen',
  page: 11
}, {
  title: 'XV. Änderungen an dieser Datenschutzrichtlinie',
  page: 12
}, {
  title: 'XVI. Kontakt',
  page: 12
}];
const DataProtection = () => {
  const theme = createTheme({
    typography: {
      fontFamily: '"Roboto","Helvetica","Arial",sans-serif'
    }
  });
  return <Wrapper skipAuth={true} data-sentry-element="Wrapper" data-sentry-component="DataProtection" data-sentry-source-file="page.jsx">
            <ThemeProvider theme={theme} data-sentry-element="ThemeProvider" data-sentry-source-file="page.jsx">
                <Box sx={{
        width: "100%",
        mx: "auto"
      }} data-sentry-element="Box" data-sentry-source-file="page.jsx">  <AppBar position="fixed" sx={{
          bgcolor: "#F7F7F7",
          boxShadow: "0",
          height: "100px",
          display: "flex",
          justifyContent: "center"
        }} data-sentry-element="AppBar" data-sentry-source-file="page.jsx">
                        <Box sx={{
            mr: 2,
            ml: 4,
            display: {
              xs: "none",
              sm: "flex"
            },
            alignItems: "center",
            maxWidth: "70px",
            maxHeight: "70px"
          }} data-sentry-element="Box" data-sentry-source-file="page.jsx">
                            <Image src="/assets/svg/login/genslogo.webp" height={100} width={100} alt="logo" data-sentry-element="Image" data-sentry-source-file="page.jsx" />
                        </Box>
                        <Typography color={"#AC1218"} sx={{
            position: "fixed",
            zIndex: "4",
            fontWeight: "700",
            fontSize: "30px",
            width: "100%",
            py: "14px",
            textAlign: "center"
          }} variant="h6" component="h2" data-sentry-element="Typography" data-sentry-source-file="page.jsx">
                            Data Protection
                        </Typography>
                    </AppBar>
                    <Box sx={{
          maxWidth: 1300,
          mx: "auto",
          marginTop: "120px"
        }} data-sentry-element="Box" data-sentry-source-file="page.jsx">
                        <Grid container sx={{
            width: "100%",
            marginLeft: "0",
            marginTop: "50px",
            padding: "20px"
          }} data-sentry-element="Grid" data-sentry-source-file="page.jsx">
                            {/* English Summary for International Visitors */}
                            <Grid item xs={12} data-sentry-element="Grid" data-sentry-source-file="page.jsx">
                                <Box sx={{
                bgcolor: "#f0f7ff",
                border: "1px solid #1976d2",
                borderRadius: "8px",
                p: 3,
                mb: 3
              }} data-sentry-element="Box" data-sentry-source-file="page.jsx">
                                    <Typography variant="h6" sx={{
                  color: "#1976d2",
                  fontWeight: "700",
                  fontSize: "18px",
                  mb: 1
                }} data-sentry-element="Typography" data-sentry-source-file="page.jsx">
                                        🇬🇧 For English Speakers
                                    </Typography>
                                    <Typography variant="body2" sx={{
                  color: "#333",
                  mb: 2
                }} data-sentry-element="Typography" data-sentry-source-file="page.jsx">
                                        As a German company, our Privacy Policy is provided in German, which is the legally binding version under EU/German data protection law (GDPR).
                                    </Typography>
                                    <Typography variant="body2" sx={{
                  fontWeight: "600",
                  color: "#333",
                  mb: 1
                }} data-sentry-element="Typography" data-sentry-source-file="page.jsx">
                                        Key Points:
                                    </Typography>
                                    <Box component="ul" sx={{
                  m: 0,
                  pl: 2,
                  color: "#333"
                }} data-sentry-element="Box" data-sentry-source-file="page.jsx">
                                        <Typography component="li" variant="body2" sx={{
                    mb: 0.5
                  }} data-sentry-element="Typography" data-sentry-source-file="page.jsx">
                                            We collect only necessary data: email, name, payment info, and usage data
                                        </Typography>
                                        <Typography component="li" variant="body2" sx={{
                    mb: 0.5
                  }} data-sentry-element="Typography" data-sentry-source-file="page.jsx">
                                            Your data is stored on EU servers (Microsoft Azure) and protected by GDPR
                                        </Typography>
                                        <Typography component="li" variant="body2" sx={{
                    mb: 0.5
                  }} data-sentry-element="Typography" data-sentry-source-file="page.jsx">
                                            We use third-party services: Crisp (chat), Stripe (payments), Microsoft Azure (hosting)
                                        </Typography>
                                        <Typography component="li" variant="body2" sx={{
                    mb: 0.5
                  }} data-sentry-element="Typography" data-sentry-source-file="page.jsx">
                                            Your rights: Access, correction, deletion, data portability, and withdrawal of consent
                                        </Typography>
                                        <Typography component="li" variant="body2" sx={{
                    mb: 0.5
                  }} data-sentry-element="Typography" data-sentry-source-file="page.jsx">
                                            We do not sell your personal data
                                        </Typography>
                                    </Box>
                                    <Typography variant="body2" sx={{
                  color: "#666",
                  mt: 2,
                  fontStyle: "italic"
                }} data-sentry-element="Typography" data-sentry-source-file="page.jsx">
                                        Questions? Contact us at{" "}
                                        <Link href="mailto:support@descripio.com" sx={{
                    color: "#1976d2"
                  }} data-sentry-element="Link" data-sentry-source-file="page.jsx">
                                            support@descripio.com
                                        </Link>
                                    </Typography>
                                </Box>
                            </Grid>

                            <Grid item xs={12} data-sentry-element="Grid" data-sentry-source-file="page.jsx">
                                <Typography variant="h6" textAlign={"left"} sx={{
                color: "black",
                fontWeight: "500",
                fontSize: "16px"
              }} data-sentry-element="Typography" data-sentry-source-file="page.jsx">
                                    Datenschutzerklärung Descripio<br />
                                    Gültig ab: 19.12.2024
                                </Typography>
                            </Grid>
                            <Grid item xs={12} sx={{
              marginTop: "20px"
            }} data-sentry-element="Grid" data-sentry-source-file="page.jsx">
                                <Typography variant="h5" gutterBottom sx={{
                color: "#AC1218"
              }} data-sentry-element="Typography" data-sentry-source-file="page.jsx">
                                    Inhalt
                                </Typography>
                                <List data-sentry-element="List" data-sentry-source-file="page.jsx">
                                    {tableOfContents.map((section, index) => <React.Fragment key={index}>
                                            <ListItem>
                                                <Grid container>
                                                    <Grid item xs={10}>
                                                        <Typography variant="body1">
                                                            {section.title}
                                                        </Typography>
                                                    </Grid>
                                                    <Grid item xs={2}>
                                                        <Typography variant="body1" align="right">
                                                            {section.page}
                                                        </Typography>
                                                    </Grid>
                                                </Grid>
                                            </ListItem>
                                            {index < tableOfContents.length - 1 && <Divider />}
                                        </React.Fragment>)}
                                </List>
                            </Grid>
                            <Grid item xs={12} sx={{
              marginTop: "40px"
            }} data-sentry-element="Grid" data-sentry-source-file="page.jsx">
                                <Typography variant="h6" textAlign={"left"} sx={{
                color: "black",
                fontWeight: "800",
                fontSize: "20px"
              }} data-sentry-element="Typography" data-sentry-source-file="page.jsx">
                                    I.	Descripio Datenschutzerklärung
                                </Typography>
                                <Typography variant="h6" textAlign={"left"} sx={{
                color: "black",
                fontWeight: "500",
                fontSize: "16px",
                marginTop: "20px"
              }} data-sentry-element="Typography" data-sentry-source-file="page.jsx">
                                    Softwaresupport Raab GmbH („Softwaresupport Raab“) ist Eigentümer und Betreiber des <strong>Descripio-</strong>Geschäfts, einschließlich der entsprechender Plattformen, Analysen, Informationen, Anwendungen, Websites und anderer Produkte und Dienstleistungen („Services“).                                </Typography>
                                <Typography variant="h6" textAlign={"left"} sx={{
                color: "black",
                fontWeight: "500",
                fontSize: "16px"
              }} data-sentry-element="Typography" data-sentry-source-file="page.jsx">
                                    Ihre Privatsphäre ist der Softwaresupport Raab („wir“, „uns“, „unser“) wichtig und wird respektiert. Wenn Sie hinsichtlich Datenschutz Fragen, Hinweise oder Wünsche haben kommen Sie jederzeit per
                                    <span style={{
                  color: "#AC1218",
                  textDecoration: "underline",
                  marginLeft: "5px"
                }}>
                                        office@raab.de.
                                    </span>

                                    oder
                                    <Link href="mailto:support@descripio.com" style={{
                  color: "#AC1218",
                  textDecoration: "underline",
                  margin: "0 5px"
                }} data-sentry-element="Link" data-sentry-source-file="page.jsx">
                                        support@descirpio.com
                                    </Link> auf uns zu.
                                </Typography>
                                <Typography variant="h6" textAlign={"left"} sx={{
                color: "black",
                fontWeight: "500",
                fontSize: "16px",
                marginTop: "20px"
              }} data-sentry-element="Typography" data-sentry-source-file="page.jsx">
                                    Diese Datenschutzerklärung beschreibt die Arten von Informationen, einschließlich personenbezogener Daten, die wir erfassen, wenn Sie unsere Website
                                    <Link href="https://descripio.com/" target="_blank" rel="noopener" sx={{
                  color: "#AC1218",
                  textDecoration: "underline",
                  marginLeft: "5px"
                }} data-sentry-element="Link" data-sentry-source-file="page.jsx">
                                        https://descripio.com/
                                    </Link>
                                    , Anwendungen (z.B. Descripio WebApp), Plattformen und Dienstleistungen (zusammen „Services“) nutzen, sowie Ihre Wahlmöglichkeiten bezüglich der Verwendung und Offenlegung Ihrer personenbezogenen Daten.
                                </Typography>
                                <Typography variant="h6" textAlign={"left"} sx={{
                color: "black",
                fontWeight: "500",
                fontSize: "16px",
                marginTop: "20px"
              }} data-sentry-element="Typography" data-sentry-source-file="page.jsx">
                                    <strong> Personenbezogene Daten</strong>  sind Informationen, die Sie direkt oder indirekt identifizieren, z.B. durch Namen, Standortdaten, Online-Kennungen oder andere Faktoren, die für Ihre Identität spezifisch sind.
                                </Typography>
                                <Typography variant="h6" textAlign={"left"} sx={{
                color: "black",
                fontWeight: "700",
                fontSize: "16px",
                marginTop: "20px"
              }} data-sentry-element="Typography" data-sentry-source-file="page.jsx">
                                    Indem Sie auf unsere Services zugreifen, stimmen Sie dieser Datenschutzerklärung zu. Jedes Mal, wenn Sie unsere Services nutzen, gilt die jeweils aktuelle Version dieser Datenschutzerklärung. Sie sollten die Datenschutzerklärung regelmäßig überprüfen, um über etwaige Änderungen informiert zu bleiben. Diese Datenschutzerklärung gilt für alle Besucher und Nutzer unserer Services.
                                </Typography>
                                <Typography variant="h6" textAlign={"left"} sx={{
                color: "black",
                fontWeight: "500",
                fontSize: "16px",
                marginTop: "20px"
              }} data-sentry-element="Typography" data-sentry-source-file="page.jsx">
                                    Darüber hinaus erkennen Sie an, dass diese Datenschutzrichtlinie Teil unserer <Link href="https://softwaresupportraabgmbh.sharepoint.com/:w:/r/sites/8-Freelancer-Descripio_Webapp/_layouts/15/Doc.aspx?sourcedoc=%7BC9C48190-2DBE-42EF-8C12-86534CA424ED%7D&file=20240114-AGB-v2.docx&action=default&mobileredirect=true" target="_blank" rel="noopener" sx={{
                  color: "#AC1218",
                  textDecoration: "underline"
                }} data-sentry-element="Link" data-sentry-source-file="page.jsx"> AGB sind. </Link>
                                    Durch den Zugriff auf oder die Nutzung unserer Services erklären Sie sich damit einverstanden, an die Nutzungsbedingungen gebunden zu sein. Wenn Sie unseren Nutzungsbedingungen nicht zustimmen, können Sie unsere Services nicht nutzen.
                                </Typography>
                                <Typography variant="h6" textAlign={"left"} sx={{
                color: "black",
                fontWeight: "500",
                fontSize: "16px",
                marginTop: "20px"
              }} data-sentry-element="Typography" data-sentry-source-file="page.jsx">
                                    Falls Sie Fragen zu unseren Datenschutzpraktiken haben, finden Sie am Ende dieser Datenschutzerklärung unsere Kontaktdaten.
                                </Typography>
                            </Grid>
                            <Grid item xs={12} sx={{
              marginTop: "40px"
            }} data-sentry-element="Grid" data-sentry-source-file="page.jsx">
                                <Typography variant="h6" textAlign={"left"} sx={{
                color: "black",
                fontWeight: "800",
                fontSize: "20px"
              }} data-sentry-element="Typography" data-sentry-source-file="page.jsx">
                                    II.	Erfassung personenbezogener Daten
                                </Typography>
                                <Typography variant="h6" textAlign={"left"} sx={{
                color: "black",
                fontWeight: "500",
                fontSize: "16px",
                marginTop: "20px"
              }} data-sentry-element="Typography" data-sentry-source-file="page.jsx">
                                    Wenn Sie unseren Service nutzen, sammeln wir Informationen (1) die Sie wissentlich und freiwillig zur Verfügung stellen (z.B. durch Formulare oder Profilbildschirme), einschließlich Informationen zur Registrierung/Kontoeinrichtung, und (2) die wir von Ihrem Webbrowser, Cookies und anderen ähnlichen Technologien sammeln können.
                                </Typography>
                                <Box sx={{
                marginLeft: 3
              }} data-sentry-element="Box" data-sentry-source-file="page.jsx">
                                    <Typography variant="h6" textAlign={"left"} sx={{
                  color: "#AC1218",
                  fontWeight: "500",
                  fontSize: "16px",
                  marginTop: "20px"
                }} data-sentry-element="Typography" data-sentry-source-file="page.jsx">
                                        A.	Daten, die Sie uns wissentlich und freiwillig bereitstellen
                                    </Typography>
                                </Box>
                                <Typography variant="h6" textAlign={"left"} sx={{
                color: "black",
                fontWeight: "500",
                fontSize: "16px",
                marginTop: "10px"
              }} data-sentry-element="Typography" data-sentry-source-file="page.jsx">
                                    Wir erfassen personenbezogene Daten, die Sie uns bewusst bereitstellen, z.B. wenn Sie ein Konto erstellen and nutzen Formulare ausfüllen oder uns direkt kontaktieren. Zu den von uns erfassten Informationen gehören:
                                </Typography>
                                <Box component="ol" sx={{
                marginLeft: 3
              }} data-sentry-element="Box" data-sentry-source-file="page.jsx">
                                    <Typography component="li" variant="body1" gutterBottom data-sentry-element="Typography" data-sentry-source-file="page.jsx">
                                        -	Vor- und Nachname
                                    </Typography>
                                    <Typography component="li" variant="body1" gutterBottom data-sentry-element="Typography" data-sentry-source-file="page.jsx">
                                        -	E-Mail-Adresse
                                    </Typography>
                                    <Typography component="li" variant="body1" gutterBottom data-sentry-element="Typography" data-sentry-source-file="page.jsx">
                                        -	Zahlungsinformationen (z.B. Kreditkartendaten)
                                    </Typography>
                                    <Typography component="li" variant="body1" gutterBottom data-sentry-element="Typography" data-sentry-source-file="page.jsx">
                                        -	Rechnungsadresse
                                    </Typography>
                                    <Typography component="li" variant="body1" gutterBottom data-sentry-element="Typography" data-sentry-source-file="page.jsx">
                                        -	Firmeninformationen
                                    </Typography>
                                    <Typography component="li" variant="body1" gutterBottom data-sentry-element="Typography" data-sentry-source-file="page.jsx">
                                        -	Ggf. Telefonnummer
                                    </Typography>
                                </Box>
                                <Typography variant="h6" textAlign={"left"} sx={{
                color: "black",
                fontWeight: "500",
                fontSize: "16px",
                marginTop: "20px"
              }} data-sentry-element="Typography" data-sentry-source-file="page.jsx">
                                    <strong> Persönliche Daten von und/oder über andere. </strong>
                                    Ggf. sammeln und speichern wir auch personenbezogene Daten über andere Personen, die Sie uns zur Verfügung stellen, sowie Informationen über Sie, die von anderen zur Verfügung gestellt werden. Wenn Sie oder andere Nutzer unseren Dienst nutzen, um Inhalte hochzuladen, freizugeben und/oder zu verbreiten (einschließlich Videos, Kommentare oder andere Beiträge), und diese Inhalte personenbezogene Daten über Sie oder andere Personen enthalten, können diese Informationen gespeichert werden, um das Hochladen, Freigeben und/oder Verbreiten zu ermöglichen. Als Voraussetzung für die Nutzung unseres Dienstes bestätigen Sie, dass Sie über die entsprechende(n) Zustimmung(en) jeder Person (oder der Eltern von Kindern unter 13 Jahren) zur Weitergabe ihrer personenbezogenen Daten an uns verfügen.
                                </Typography>
                                <Typography variant="h6" textAlign={"left"} sx={{
                color: "black",
                fontWeight: "500",
                fontSize: "16px",
                marginTop: "20px"
              }} data-sentry-element="Typography" data-sentry-source-file="page.jsx">
                                    Wir können Ihre personenbezogenen Daten auch von vertrauenswürdigen Dritten erhalten (z. B. von Geschäftspartnern, Unterauftragnehmern in den Bereichen Technik, Zahlung und Bereitstellung von Mitgliedschaftsdiensten, Werbenetzwerken, Analyseanbietern, Anbietern von Suchinformationen und Kreditauskunfteien).
                                </Typography>
                                <Box sx={{
                marginLeft: 3
              }} data-sentry-element="Box" data-sentry-source-file="page.jsx">
                                    <Typography variant="h6" textAlign={"left"} sx={{
                  color: "#AC1218",
                  fontWeight: "500",
                  fontSize: "16px",
                  marginTop: "20px"
                }} data-sentry-element="Typography" data-sentry-source-file="page.jsx">
                                        B.	Automatisch erfasste Daten
                                    </Typography>
                                </Box>
                                <Typography variant="h6" textAlign={"left"} sx={{
                color: "black",
                fontWeight: "500",
                fontSize: "16px",
                marginTop: "10px"
              }} data-sentry-element="Typography" data-sentry-source-file="page.jsx">
                                    Bei der Nutzung unserer Services erfassen wir automatisch Informationen (zum Beispiel Interaktionsdaten). Diese Daten helfen uns, die Nutzung unserer Services zu analysieren und beinhalten:
                                </Typography>
                                <Box component="ol" sx={{
                marginLeft: 3
              }} data-sentry-element="Box" data-sentry-source-file="page.jsx">
                                    <Typography component="li" variant="body1" gutterBottom data-sentry-element="Typography" data-sentry-source-file="page.jsx">
                                        -	IP-Adresse
                                    </Typography>
                                    <Typography component="li" variant="body1" gutterBottom data-sentry-element="Typography" data-sentry-source-file="page.jsx">
                                        -	Browser-Typ
                                    </Typography>
                                    <Typography component="li" variant="body1" gutterBottom data-sentry-element="Typography" data-sentry-source-file="page.jsx">
                                        -	Details zum Browser-Plug-In
                                    </Typography>
                                    <Typography component="li" variant="body1" gutterBottom data-sentry-element="Typography" data-sentry-source-file="page.jsx">
                                        -	Betriebssytem
                                    </Typography>
                                    <Typography component="li" variant="body1" gutterBottom data-sentry-element="Typography" data-sentry-source-file="page.jsx">
                                        -	Lokale Zeitzone
                                    </Typography>
                                    <Typography component="li" variant="body1" gutterBottom data-sentry-element="Typography" data-sentry-source-file="page.jsx">
                                        -	Datum und Uhrzeit der einzelnen Besucheranfragen/Sitzungen
                                        (z. B. ausgewählte Webseiten und Verweildauer auf den einzelnen Seiten)
                                    </Typography>
                                    <Typography component="li" variant="body1" gutterBottom data-sentry-element="Typography" data-sentry-source-file="page.jsx">
                                        -	Verweisende Website und/oder Suchmaschine
                                    </Typography>
                                    <Typography component="li" variant="body1" gutterBottom data-sentry-element="Typography" data-sentry-source-file="page.jsx">
                                        -	Gerätetyp (z. B. Desktop, Laptop, Tablet, Telefon usw.)
                                    </Typography>
                                    <Typography component="li" variant="body1" gutterBottom data-sentry-element="Typography" data-sentry-source-file="page.jsx">
                                        -	Bildschirmgröße, -farbe, -tiefe und Systemschriftarten
                                    </Typography>
                                    <Typography component="li" variant="body1" gutterBottom data-sentry-element="Typography" data-sentry-source-file="page.jsx">
                                        -	Bevorzugte Sprache
                                    </Typography>
                                </Box>
                                <Typography variant="h6" textAlign={"left"} sx={{
                color: "black",
                fontWeight: "500",
                fontSize: "16px",
                marginTop: "20px"
              }} data-sentry-element="Typography" data-sentry-source-file="page.jsx">
                                    Diese Informationen werden in sogenannten „Server-Log-Dateien“ gespeichert. Diese Speicherung erfolgt auf Grundlage von Art. 6 Abs. 1 f DSGVO. Wir haben ein berechtigtes Interesse an der fehlerfreien Bereitstellung und Optimierung unserer Website.
                                </Typography>
                                <Typography variant="h6" textAlign={"left"} sx={{
                color: "black",
                fontWeight: "500",
                fontSize: "16px",
                marginTop: "20px"
              }} data-sentry-element="Typography" data-sentry-source-file="page.jsx">
                                    Wir nutzen außerdem Drittanbieter-Dienste wie
                                    <Link href="https://crisp.chat/de/" target="_blank" rel="noopener" sx={{
                  color: "#AC1218",
                  textDecoration: "underline",
                  marginLeft: "5px"
                }} data-sentry-element="Link" data-sentry-source-file="page.jsx"> https://crisp.chat/de/  </Link>

                                    (Crisp im Wesentlichen für die Bereitstellung von Live-Chat- und Kommunikationsdiensten), Microsoft Azure (im Wesentlichen für die Speicherung und Verarbeitung von User-Daten - insbesondere Log-In-Daten),
                                    <Link href="https://stripe.com/de" target="_blank" rel="noopener" sx={{
                  color: "#AC1218",
                  textDecoration: "underline",
                  marginLeft: "5px"
                }} data-sentry-element="Link" data-sentry-source-file="page.jsx"> https://stripe.com/de </Link>
                                    (Stripe im Falle einer kostenpflichtigen Nutzung von Descripio für die Zahlungsabwicklung) sowie
                                    <Link href="https://clarity.microsoft.com/" target="_blank" rel="noopener" sx={{
                  color: "#AC1218",
                  textDecoration: "underline",
                  marginLeft: "5px"
                }} data-sentry-element="Link" data-sentry-source-file="page.jsx"> Microsoft Clarity </Link>
                                    (für Analyse- und Optimierungszwecke zur Verbesserung der Benutzerfreundlichkeit unserer Services). Dabei können diese Drittanbieter personenbezogene Daten verarbeiten, die für die Bereitstellung ihrer Dienste erforderlich sind. Hierzu können zusätzlich folgende Daten gehören:                                </Typography>
                                <Box component="ol" sx={{
                marginLeft: 3
              }} data-sentry-element="Box" data-sentry-source-file="page.jsx">
                                    <Typography component="li" variant="body1" gutterBottom data-sentry-element="Typography" data-sentry-source-file="page.jsx">
                                        -   An uns gesendete Nachrichten (Crisp)
                                    </Typography>
                                    <Typography component="li" variant="body1" gutterBottom data-sentry-element="Typography" data-sentry-source-file="page.jsx">
                                        -	Aktivitätsstatus: online/offline (Crisp)
                                    </Typography>
                                    <Typography component="li" variant="body1" gutterBottom data-sentry-element="Typography" data-sentry-source-file="page.jsx">
                                        -	Nutzerinteraktionen, Sitzungsaufzeichnungen, Heatmaps und interne Kennungen wie Store-ID für angemeldete Nutzer (Microsoft Clarity für Analytics)
                                    </Typography>
                                </Box>

                                <Typography variant="h6" textAlign={"left"} sx={{
                color: "black",
                fontWeight: "500",
                fontSize: "16px",
                marginTop: "20px"
              }} data-sentry-element="Typography" data-sentry-source-file="page.jsx">
                                    <strong>Microsoft Clarity (Analytics):</strong> Für angemeldete Nutzer wird Microsoft Clarity gemäß unseren Nutzungsbedingungen (T&C) automatisch aktiviert. Dabei werden pseudonyme Kennungen wie Ihre Store-ID verwendet, um Ihre Sitzungen zu identifizieren und uns bei der Bereitstellung von besserem Support und der Verbesserung unserer Services zu unterstützen. Für nicht angemeldete Besucher wird Microsoft Clarity nur mit Ihrer ausdrücklichen Zustimmung über unser Cookie-Banner aktiviert.
                                </Typography>

                                <Typography variant="h6" textAlign={"left"} sx={{
                color: "black",
                fontWeight: "500",
                fontSize: "16px",
                marginTop: "20px"
              }} data-sentry-element="Typography" data-sentry-source-file="page.jsx">
                                    Darüber hinaus können wir nicht-personenbezogene Daten für verschiedene Geschäftszwecke verwenden, wie z.B. Kundenservice, Betrugsprävention, Marktforschung und die Verbesserung unseres Services.  Die Informationen, die wir erhalten, hängen von den Einstellungen Ihres Browsers ab.  Bitte überprüfen Sie Ihren Browser, wenn Sie wissen möchten, welche Informationen Ihr Browser sendet oder wie Sie Ihre Einstellungen ändern können.
                                </Typography>
                                <Box sx={{
                marginLeft: 3
              }} data-sentry-element="Box" data-sentry-source-file="page.jsx">
                                    <Typography variant="h6" textAlign={"left"} sx={{
                  color: "#AC1218",
                  fontWeight: "500",
                  fontSize: "16px",
                  marginTop: "20px"
                }} data-sentry-element="Typography" data-sentry-source-file="page.jsx">
                                        C.	Anonymisierung und Zusammenfassung von Daten                                </Typography>
                                </Box>
                                <Typography variant="h6" textAlign={"left"} sx={{
                color: "black",
                fontWeight: "500",
                fontSize: "16px",
                marginTop: "10px"
              }} data-sentry-element="Typography" data-sentry-source-file="page.jsx">
                                    Wir können alle Informationen, die wir von Ihnen sammeln, einschließlich personenbezogener Daten, zusammenfassen und/oder anonymisieren und/oder pseudonymisieren.
                                </Typography>
                                <Typography variant="h6" textAlign={"left"} sx={{
                color: "black",
                fontWeight: "500",
                fontSize: "16px",
                marginTop: "10px"
              }} data-sentry-element="Typography" data-sentry-source-file="page.jsx">
                                    Dies kann zu Zwecken der Marktforschung über Marken und Produkte, Marketingkampagnen und Werbung geschehen. Personenbezogene Daten, die durch Cookies, Web Beacons und andere Technologien gesammelt werden.
                                </Typography>
                                <Box sx={{
                marginLeft: 3
              }} data-sentry-element="Box" data-sentry-source-file="page.jsx">
                                    <Typography variant="h6" textAlign={"left"} sx={{
                  color: "#AC1218",
                  fontWeight: "500",
                  fontSize: "16px",
                  marginTop: "20px"
                }} data-sentry-element="Typography" data-sentry-source-file="page.jsx">
                                        D.	Cookies und ähnliche Technologien
                                    </Typography>
                                </Box>
                                <Typography variant="h6" textAlign={"left"} sx={{
                color: "black",
                fontWeight: "500",
                fontSize: "16px",
                marginTop: "10px"
              }} data-sentry-element="Typography" data-sentry-source-file="page.jsx">
                                    Unsere Services verwenden so genannte „Cookies“. Cookies sind kleine Textdateien und richten auf Ihrem Endgerät keinen Schaden an. Sie werden entweder vorübergehend für die Dauer einer Sitzung (Session-Cookies) oder dauerhaft (permanente Cookies) auf Ihrem Endgerät gespeichert. Session-Cookies werden nach Ende Ihres Besuchs automatisch gelöscht. Permanente Cookies bleiben auf Ihrem Endgerät gespeichert, bis Sie diese selbst löschen oder eine automatische Löschung durch Ihren Webbrowser erfolgt.
                                </Typography>
                                <Typography variant="h6" textAlign={"left"} sx={{
                color: "black",
                fontWeight: "500",
                fontSize: "16px",
                marginTop: "10px"
              }} data-sentry-element="Typography" data-sentry-source-file="page.jsx">
                                    Teilweise können auch Cookies von Drittunternehmen auf Ihrem Endgerät gespeichert werden, wenn Sie unsere Seite betreten (Third-Party-Cookies). Diese ermöglichen uns oder Ihnen die Nutzung bestimmter Dienstleistungen des Drittunternehmens (z.B. Cookies zur Abwicklung von Zahlungsdienstleistungen).
                                </Typography>
                                <Typography variant="h6" textAlign={"left"} sx={{
                color: "black",
                fontWeight: "500",
                fontSize: "16px",
                marginTop: "10px"
              }} data-sentry-element="Typography" data-sentry-source-file="page.jsx">
                                    Cookies haben verschiedene Funktionen. Zahlreiche Cookies sind technisch notwendig, da bestimmte Websitefunktionen ohne diese nicht funktionieren würden (z.B. die Warenkorbfunktion oder die Anzeige von Videos). Andere Cookies dienen dazu, das Nutzerverhalten auszuwerten oder Werbung anzuzeigen.
                                </Typography>
                                <Typography variant="h6" textAlign={"left"} sx={{
                color: "black",
                fontWeight: "500",
                fontSize: "16px",
                marginTop: "10px"
              }} data-sentry-element="Typography" data-sentry-source-file="page.jsx">
                                    Cookies, die zur Durchführung des elektronischen Kommunikationsvorgangs (notwendige Cookies) oder zur Bereitstellung bestimmter, von Ihnen erwünschter Funktionen (funktionale Cookies, z. B. für die Warenkorbfunktion) oder zur Optimierung der Website (z.B. Cookies zur Messung des Webpublikums) erforderlich sind, werden auf Grundlage von Art. 6 Abs. 1 f DSGVO gespeichert, sofern keine andere Rechtsgrundlage angegeben wird.
                                </Typography>
                                <Typography variant="h6" textAlign={"left"} sx={{
                color: "black",
                fontWeight: "500",
                fontSize: "16px",
                marginTop: "10px"
              }} data-sentry-element="Typography" data-sentry-source-file="page.jsx">
                                    Für den Einsatz von nicht notwendigen Cookies und ähnlichen Tracking-Technologien, die nicht für den Betrieb unserer Services erforderlich sind, holen wir Ihre ausdrückliche Einwilligung gemäß Art. 6 Abs. 1 a DSGVO ein. Dies erfolgt im Fall unserer Website über ein Cookie-Banner, das beim erstmaligen Besuch unserer Website angezeigt wird. In diesem Banner haben Sie die Möglichkeit, den Einsatz solcher Cookies zu akzeptieren oder abzulehnen. Sie können Ihre Einwilligung jederzeit widerrufen, indem Sie Ihre Cookie-Einstellungen anpassen. Ohne Ihre Einwilligung werden keine nicht notwendigen Cookies gesetzt.
                                </Typography>
                                <Typography variant="h6" textAlign={"left"} sx={{
                color: "black",
                fontWeight: "500",
                fontSize: "16px",
                marginTop: "10px"
              }} data-sentry-element="Typography" data-sentry-source-file="page.jsx">
                                    Der Websitebetreiber hat ein berechtigtes Interesse an der Speicherung von Cookies zur technisch fehlerfreien und optimierten Bereitstellung seiner Dienste. Sofern eine Einwilligung zur Speicherung von Cookies abgefragt wurde, erfolgt die Speicherung der betreffenden Cookies ausschließlich auf Grundlage dieser Einwilligung (Art. 6 Abs. 1 a DSGVO); die Einwilligung ist jederzeit widerrufbar.
                                </Typography>
                                <Typography variant="h6" textAlign={"left"} sx={{
                color: "black",
                fontWeight: "500",
                fontSize: "16px",
                marginTop: "10px"
              }} data-sentry-element="Typography" data-sentry-source-file="page.jsx">
                                    Sie können Ihren Browser so einstellen, dass Sie über das Setzen von Cookies informiert werden und Cookies nur im Einzelfall erlauben, die Annahme von Cookies für bestimmte Fälle oder generell ausschließen sowie das automatische Löschen der Cookies beim Schließen des Browsers aktivieren.
                                </Typography>
                                <Typography variant="h6" textAlign={"left"} sx={{
                color: "black",
                fontWeight: "500",
                fontSize: "16px",
                marginTop: "10px"
              }} data-sentry-element="Typography" data-sentry-source-file="page.jsx">
                                    Wenn Sie die Verwendung von Cookies bei Ihrem Besuch bei Descripio einschränken oder deaktivieren, können Sie möglicherweise nicht die volle Funktionalität unserer Services nutzen. Weitere Informationen über Cookies finden Sie unter: http://www.allaboutcookies.org.
                                </Typography>
                                <Typography variant="h6" textAlign={"left"} sx={{
                color: "black",
                fontWeight: "500",
                fontSize: "16px",
                marginTop: "10px"
              }} data-sentry-element="Typography" data-sentry-source-file="page.jsx">
                                    Soweit Cookies von Drittunternehmen oder zu Analysezwecken eingesetzt werden, werden wir Sie hierüber im Rahmen dieser Datenschutzerklärung gesondert informieren und ggf. eine Einwilligung abfragen.
                                </Typography>
                                <Typography variant="h6" textAlign={"left"} sx={{
                color: "black",
                fontWeight: "500",
                fontSize: "16px",
                marginTop: "10px"
              }} data-sentry-element="Typography" data-sentry-source-file="page.jsx">
                                    Wir verwenden diese

                                    <Link href="https://descripio.com/datenschutzerklaerung/#Cookies" target="_blank" rel="noopener" sx={{
                  color: "#AC1218",
                  textDecoration: "underline",
                  marginLeft: "5px"
                }} data-sentry-element="Link" data-sentry-source-file="page.jsx">
                                        Cookies.

                                    </Link>


                                </Typography>
                            </Grid>
                            <Grid item xs={12} sx={{
              marginTop: "40px"
            }} data-sentry-element="Grid" data-sentry-source-file="page.jsx">
                                <Typography variant="h6" textAlign={"left"} sx={{
                color: "black",
                fontWeight: "800",
                fontSize: "20px"
              }} data-sentry-element="Typography" data-sentry-source-file="page.jsx">
                                    III.	 Hosting und Content Delivery Networks (CDN)
                                </Typography>
                                <Typography variant="h6" textAlign={"left"} sx={{
                color: "black",
                fontWeight: "500",
                fontSize: "16px",
                marginTop: "20px"
              }} data-sentry-element="Typography" data-sentry-source-file="page.jsx">
                                    Unsere Services werden bei externen Dienstleistern gehostet (Hoster). Personenbezogene Daten, die durch unsere Services erfasst werden, werden auf den Servern des Hosters gespeichert. Dies umfasst IP-Adressen, Kontaktanfragen, Meta- und Kommunikationsdaten, Vertragsdaten und andere durch die Nutzung unserer Services erhobene Daten.
                                </Typography>
                                <Typography variant="h6" textAlign={"left"} sx={{
                color: "black",
                fontWeight: "500",
                fontSize: "16px",
                marginTop: "20px"
              }} data-sentry-element="Typography" data-sentry-source-file="page.jsx">
                                    Die Nutzung eines externen Hosters erfolgt auf Grundlage von Art. 6 Abs. 1 b DSGVO (Vertragserfüllung) und Art. 6 Abs. 1 f DSGVO (berechtigtes Interesse an der sicheren und effizienten Bereitstellung unseres Online-Angebots).
                                </Typography>
                                <Typography variant="h6" textAlign={"left"} sx={{
                color: "black",
                fontWeight: "500",
                fontSize: "16px",
                marginTop: "20px"
              }} data-sentry-element="Typography" data-sentry-source-file="page.jsx">
                                    Unser Hoster wird Ihre Daten nur insoweit verarbeiten, wie dies zur Erfüllung seiner Leistungspflichten erforderlich ist, und unsere Weisungen in Bezug auf diese Daten befolgen.
                                </Typography>
                            </Grid>
                            <Grid item xs={12} sx={{
              marginTop: "40px"
            }} data-sentry-element="Grid" data-sentry-source-file="page.jsx">
                                <Typography variant="h6" textAlign={"left"} sx={{
                color: "black",
                fontWeight: "800",
                fontSize: "20px"
              }} data-sentry-element="Typography" data-sentry-source-file="page.jsx">
                                    IV.	Verwendung Ihrer personenbezogenen Daten
                                </Typography>
                                <Typography variant="h6" textAlign={"left"} sx={{
                color: "black",
                fontWeight: "500",
                fontSize: "16px",
                marginTop: "20px"
              }} data-sentry-element="Typography" data-sentry-source-file="page.jsx">
                                    Wir werden Ihre personenbezogenen Daten nur dann verarbeiten, einschließlich der Weitergabe an Dritte, wenn (1) Sie Ihre Einwilligung gegeben haben (Art. 6 Abs. 1 a DSGVO),
                                    <strong> die Sie jederzeit widerrufen können, indem Sie sich beispielsweise an
                                        <Link href="mailto:support@descripio.com" style={{
                    color: "#AC1218",
                    textDecoration: "underline",
                    margin: "0 5px"
                  }} data-sentry-element="Link" data-sentry-source-file="page.jsx">
                                            support@descirpio.com
                                        </Link>
                                        wenden,</strong> (2) die Verarbeitung für die Erfüllung eines Vertrages erforderlich ist (Art. 6 Abs. 1 b DSGVO), dessen Vertragspartei Sie sind, (3) wir gesetzlich dazu verpflichtet sind, (4) die Verarbeitung erforderlich ist, um Ihre lebenswichtigen Interessen oder die einer anderen Person zu schützen, oder (5) die Verarbeitung für die Zwecke unserer legitimen geschäftlichen Interessen erforderlich ist, es sei denn, diese Interessen werden durch Ihre Rechte und Interessen überlagert (Art. 6 Abs. 1 f DSGVO).
                                </Typography>
                                <Typography variant="h6" textAlign={"left"} sx={{
                color: "black",
                fontWeight: "500",
                fontSize: "16px",
                marginTop: "20px"
              }} data-sentry-element="Typography" data-sentry-source-file="page.jsx">
                                    In diesem Rahmen können wir personenbezogene Daten, allein oder in Kombination mit anderen Informationen, die wir über Sie haben, verwenden, um:
                                </Typography>
                                <Box component="ol" sx={{
                marginLeft: 3
              }} data-sentry-element="Box" data-sentry-source-file="page.jsx">
                                    <Typography component="li" variant="body1" gutterBottom data-sentry-element="Typography" data-sentry-source-file="page.jsx">
                                        -	Benutzerkonten und/oder Profile durch Registrierung zu erstellen;
                                    </Typography>
                                    <Typography component="li" variant="body1" gutterBottom data-sentry-element="Typography" data-sentry-source-file="page.jsx">
                                        -	Interne Vorgänge durchzuführen, wie z. B. die Verfolgung und Verbesserung der Effektivität unserer Website, unserer mobilen Erfahrung und unserer Marketingmaßnahmen;
                                    </Typography>
                                    <Typography component="li" variant="body1" gutterBottom data-sentry-element="Typography" data-sentry-source-file="page.jsx">
                                        -	Produkt- und/oder Serviceabwicklung, wie z. B. die Erstellung von Konten, die Verwaltung von Einkäufen, Zahlungen und mehr;
                                    </Typography>
                                    <Typography component="li" variant="body1" gutterBottom data-sentry-element="Typography" data-sentry-source-file="page.jsx">
                                        -	Personalisierung der Benutzererfahrung, z. B. Speicherung Ihrer Einstellungen und Präferenzen für Dinge wie Sprache, Schriftgröße usw.;
                                    </Typography>
                                    <Typography component="li" variant="body1" gutterBottom data-sentry-element="Typography" data-sentry-source-file="page.jsx">
                                        -	Unterstützung bereit zu stellen;
                                    </Typography>
                                    <Typography component="li" variant="body1" gutterBottom data-sentry-element="Typography" data-sentry-source-file="page.jsx">
                                        -	Beilegung von Streitigkeiten zwischen Nutzern und/oder zwischen einem Nutzer und dem Unternehmen, wie in unseren Nutzungsbedingungen dargelegt;
                                    </Typography>
                                    <Typography component="li" variant="body1" gutterBottom data-sentry-element="Typography" data-sentry-source-file="page.jsx">
                                        -	Verwendung des Standorts Ihres Geräts zur Verhinderung von Betrug oder zur Bereitstellung anderer standortbezogener Dienste, die Sie anfordern können;
                                    </Typography>
                                    <Typography component="li" variant="body1" gutterBottom data-sentry-element="Typography" data-sentry-source-file="page.jsx">
                                        -	ein Gewinnspiel, einen Wettbewerb oder eine ähnliche Aktion zu verwalten;
                                    </Typography>
                                    <Typography component="li" variant="body1" gutterBottom data-sentry-element="Typography" data-sentry-source-file="page.jsx">
                                        -	Werbung und Marketing für unsere Produkte und Dienste - und die unserer Geschäftspartner -, einschließlich der folgenden Zwecke
                                    </Typography>
                                    <Box component="ol" sx={{
                  marginLeft: 2
                }} data-sentry-element="Box" data-sentry-source-file="page.jsx">
                                        <Typography component="li" variant="body1" gutterBottom data-sentry-element="Typography" data-sentry-source-file="page.jsx">
                                            Gezielte Werbung zu präsentieren, Ihnen Werbung, Promotionen und Angebote zu senden oder bereitzustellen;
                                        </Typography>
                                        <Typography component="li" variant="body1" gutterBottom data-sentry-element="Typography" data-sentry-source-file="page.jsx">
                                            zu analysieren, ob unsere Werbung, Promotionen und Angebote effektiv sind;
                                        </Typography>
                                        <Typography component="li" variant="body1" gutterBottom data-sentry-element="Typography" data-sentry-source-file="page.jsx">
                                            um festzustellen, ob Sie an neuen Produkten oder Dienstleistungen interessiert sind
                                        </Typography>
                                        <Typography component="li" variant="body1" gutterBottom data-sentry-element="Typography" data-sentry-source-file="page.jsx">
                                            Erfahrungsberichte von Kunden
                                        </Typography>
                                    </Box>
                                    <Typography component="li" variant="body1" gutterBottom data-sentry-element="Typography" data-sentry-source-file="page.jsx">
                                        -	Umfragen durchführen;
                                    </Typography>
                                    <Typography component="li" variant="body1" gutterBottom data-sentry-element="Typography" data-sentry-source-file="page.jsx">
                                        -	Forschung betreiben;
                                    </Typography>
                                    <Typography component="li" variant="body1" gutterBottom data-sentry-element="Typography" data-sentry-source-file="page.jsx">
                                        -	Feedback einholen;
                                    </Typography>
                                    <Typography component="li" variant="body1" gutterBottom data-sentry-element="Typography" data-sentry-source-file="page.jsx">
                                        -	Audits durchführen;
                                    </Typography>
                                    <Typography component="li" variant="body1" gutterBottom data-sentry-element="Typography" data-sentry-source-file="page.jsx">
                                        -	Bereitstellung von Informationen für unsere Geschäftspartner;
                                    </Typography>
                                    <Typography component="li" variant="body1" gutterBottom data-sentry-element="Typography" data-sentry-source-file="page.jsx">
                                        -	Bereitstellung von Informationen für die Medien;
                                    </Typography>
                                    <Typography component="li" variant="body1" gutterBottom data-sentry-element="Typography" data-sentry-source-file="page.jsx">
                                        -	Bereitstellung von Informationen für unsere Lieferanten;
                                    </Typography>
                                    <Typography component="li" variant="body1" gutterBottom data-sentry-element="Typography" data-sentry-source-file="page.jsx">
                                        -	Weitergabe von Informationen an unsere Vertreter und/oder Berater, wie z. B. unsere Anwälte, Buchhalter und andere, um uns bei der Einhaltung von rechtlichen, buchhalterischen oder sicherheitsrelevanten Anforderungen zu unterstützen;
                                    </Typography>
                                    <Typography component="li" variant="body1" gutterBottom data-sentry-element="Typography" data-sentry-source-file="page.jsx">
                                        -	Weitergabe Ihrer Daten, z. B. im Rahmen einer Fusion oder eines Verkaufs des Unternehmens;
                                    </Typography>
                                    <Typography component="li" variant="body1" gutterBottom data-sentry-element="Typography" data-sentry-source-file="page.jsx">
                                        -	Schutz der Rechte, der Sicherheit und der Informationen unserer Mitglieder, Dritter sowie unserer eigenen.  Dazu gehören Betrugsprävention, Geschäfts- oder Produktrückrufe, die Verfolgung und Verteidigung eines Schiedsgerichtsverfahrens oder eines ähnlichen Verfahrens und vieles mehr;
                                    </Typography>
                                    <Typography component="li" variant="body1" gutterBottom data-sentry-element="Typography" data-sentry-source-file="page.jsx">
                                        -	Einhaltung gesetzlicher Vorschriften
                                    </Typography>
                                    <Typography component="li" variant="body1" gutterBottom data-sentry-element="Typography" data-sentry-source-file="page.jsx">
                                        -	Wir können Ihre persönlichen Daten auch wie in dieser Datenschutzrichtlinie dargelegt, wie gesetzlich zulässig oder mit Ihrer Zustimmung weitergeben.
                                    </Typography>
                                </Box>
                                <Typography variant="body1" gutterBottom data-sentry-element="Typography" data-sentry-source-file="page.jsx">
                                    Sofern gem. DSGVO für einen oder mehrere dieser Verwendungszwecke eine gesonderte Zustimmung durch den Nutzer erforderlich ist, holen wir diese gesondert ein.
                                    <strong> Jede Marketingkommunikation enthält eine einfache Abmeldemöglichkeit. Wenden Sie sich dazu beispielsweise an
                                        <Link href="mailto:support@descripio.com" style={{
                    color: "#AC1218",
                    textDecoration: "underline",
                    margin: "0 5px"
                  }} data-sentry-element="Link" data-sentry-source-file="page.jsx">
                                            support@descirpio.com
                                        </Link>
                                    </strong>
                                </Typography>
                            </Grid>
                            <Grid item xs={12} sx={{
              marginTop: "40px"
            }} data-sentry-element="Grid" data-sentry-source-file="page.jsx">
                                <Typography variant="h6" textAlign={"left"} sx={{
                color: "black",
                fontWeight: "800",
                fontSize: "20px"
              }} data-sentry-element="Typography" data-sentry-source-file="page.jsx">
                                    V.	Rechtsgrundlagen für die Verarbeitung
                                </Typography>
                                <Typography variant="h6" textAlign={"left"} sx={{
                color: "black",
                fontWeight: "500",
                fontSize: "16px",
                marginTop: "20px"
              }} data-sentry-element="Typography" data-sentry-source-file="page.jsx">
                                    Wir verarbeiten Ihre personenbezogenen Daten nur, wenn eine Rechtsgrundlagen gemäß der DSGVO erfüllt ist. Diese sind insbesondere:
                                </Typography>
                                <Box component="ol" sx={{
                marginLeft: 3
              }} data-sentry-element="Box" data-sentry-source-file="page.jsx">
                                    <Typography component="li" variant="body1" gutterBottom data-sentry-element="Typography" data-sentry-source-file="page.jsx">
                                        -	Art. 6 Abs. 1 b DSGVO: Die Verarbeitung ist zur Erfüllung eines Vertrags erforderlich, z.B. um Ihnen die Services zur Verfügung zu stellen.
                                    </Typography>
                                    <Typography component="li" variant="body1" gutterBottom data-sentry-element="Typography" data-sentry-source-file="page.jsx">
                                        -	Art. 6 Abs. 1 f DSGVO: Wir haben ein berechtigtes Interesse an der Verarbeitung Ihrer Daten, z.B. zur Verbesserung unserer Services und zur Sicherheit.
                                    </Typography>
                                    <Typography component="li" variant="body1" gutterBottom data-sentry-element="Typography" data-sentry-source-file="page.jsx">
                                        -	Art. 6 Abs. 1 a DSGVO: Sie haben in die Verarbeitung Ihrer personenbezogenen Daten für bestimmte Zwecke, wie z.B. Marketing, eingewilligt.
                                    </Typography>
                                    <Typography component="li" variant="body1" gutterBottom data-sentry-element="Typography" data-sentry-source-file="page.jsx">
                                        -	Art. 6 Abs. 1 c DSGVO: Wir sind rechtlich verpflichtet, bestimmte Daten zu verarbeiten, z.B. zur Einhaltung steuerlicher oder buchhalterischer Vorgaben.
                                    </Typography>
                                </Box>
                            </Grid>
                            <Grid item xs={12} sx={{
              marginTop: "40px"
            }} data-sentry-element="Grid" data-sentry-source-file="page.jsx">
                                <Typography variant="h6" textAlign={"left"} sx={{
                color: "black",
                fontWeight: "800",
                fontSize: "20px"
              }} data-sentry-element="Typography" data-sentry-source-file="page.jsx">
                                    VI.	Weitergabe Ihrer personenbezogenen Daten
                                </Typography>
                                <Typography variant="h6" textAlign={"left"} sx={{
                color: "black",
                fontWeight: "500",
                fontSize: "16px",
                marginTop: "20px"
              }} data-sentry-element="Typography" data-sentry-source-file="page.jsx">
                                    Wir übermitteln Ihre personenbezogenen Daten nur an vertrauenswürdige Dritte, die ausreichende Garantien in Bezug auf die technischen und organisatorischen Sicherheitsmaßnahmen für die durchzuführende Verarbeitung bieten und die nachweisen können, dass sie sich zur Einhaltung dieser Maßnahmen verpflichten.
                                </Typography>
                                <Typography variant="h6" textAlign={"left"} sx={{
                color: "black",
                fontWeight: "500",
                fontSize: "16px",
                marginTop: "20px"
              }} data-sentry-element="Typography" data-sentry-source-file="page.jsx">
                                    Wenn Dritte personenbezogene Daten in unserem Auftrag verarbeiten, müssen sie sich vertraglich oder anderweitig verpflichten, die personenbezogenen Daten in Übereinstimmung mit dem geltenden Recht zu verarbeiten. In diesem Vertrag wird unter anderem festgelegt, dass der Dritte und sein Vertreter nur auf unsere Anweisungen hin oder in Übereinstimmung mit den gesetzlichen Bestimmungen handeln dürfen.
                                </Typography>
                                <Typography variant="h6" textAlign={"left"} sx={{
                color: "black",
                fontWeight: "500",
                fontSize: "16px",
                marginTop: "20px"
              }} data-sentry-element="Typography" data-sentry-source-file="page.jsx">
                                    Wir können Ihre personenbezogenen Daten in den folgenden Fällen weitergeben:
                                </Typography>
                                <Box component="ol" sx={{
                marginLeft: 3
              }} data-sentry-element="Box" data-sentry-source-file="page.jsx">
                                    <Typography component="li" variant="body1" gutterBottom data-sentry-element="Typography" data-sentry-source-file="page.jsx">
                                        -	Dienstleister: Wir setzen externe Dienstleister ein, die uns bei der Bereitstellung unserer Services unterstützen, z.B. Zahlungsabwickler, IT-Dienstleister oder Marketingagenturen. Insbesondere nutzen wir folgende Drittanbieterdienste:
                                        <Box component="ul" sx={{
                    marginLeft: 3
                  }} data-sentry-element="Box" data-sentry-source-file="page.jsx">
                                            <Typography component="li" variant="body1" gutterBottom data-sentry-element="Typography" data-sentry-source-file="page.jsx">
                                                Crisp: Bereitstellung von Live-Chat- und Kommunikationsdiensten.                                     </Typography>
                                            <Typography component="li" variant="body1" gutterBottom data-sentry-element="Typography" data-sentry-source-file="page.jsx">
                                                Microsoft Azure: Speicherung und Verarbeitung von User-Daten (insbesondere Log-In)                                     </Typography>
                                            <Typography component="li" variant="body1" gutterBottom data-sentry-element="Typography" data-sentry-source-file="page.jsx">
                                                Stripe: Abwicklung von Zahlungsprozessen für kostenpflichtige Abonnements.                                     </Typography>
                                        </Box>

                                        Diese Dienstleister verarbeiten personenbezogene Daten ausschließlich auf Grundlage von Verträgen, die den Anforderungen der DSGVO entsprechen, und gemäß unserer Weisungen.
                                        Sofern notwendig, schließen wir hier eine gesonderte Auftragsdatenvereinbarung (AVV) ab.

                                    </Typography>

                                    <Typography component="li" variant="body1" gutterBottom data-sentry-element="Typography" data-sentry-source-file="page.jsx">
                                        -	Gesetzliche Anforderungen: Wenn wir gesetzlich verpflichtet sind, Ihre Daten offenzulegen, z.B. im Rahmen von rechtlichen Verfahren oder zur Durchsetzung unserer Rechte.
                                    </Typography>
                                    <Typography component="li" variant="body1" gutterBottom data-sentry-element="Typography" data-sentry-source-file="page.jsx">
                                        -	Verbundenen Unternehmen: Daten können an unsere Tochtergesellschaften und verbundenen Unternehmen weitergegeben werden.
                                    </Typography>
                                </Box>
                                <Typography variant="body1" gutterBottom data-sentry-element="Typography" data-sentry-source-file="page.jsx">
                                    Beispiele hierfür sind:
                                </Typography>
                                <Typography variant="body1" gutterBottom data-sentry-element="Typography" data-sentry-source-file="page.jsx">
                                    <strong sx={{
                  fontFamily: "inherit"
                }}>
                                        Bevollmächtigte.
                                    </strong>
                                    Wir beauftragen andere Unternehmen und Einzelpersonen mit der Ausführung von Aufgaben in unserem Namen. Beispiele für solche Funktionen sind die Ausführung von Bestellungen, die Zustellung von Paketen, der Versand von Post und E-Mails, die Entfernung von sich wiederholenden Informationen aus Kundenlisten, die Analyse von Daten, die Bereitstellung von technischem Support, die Bereitstellung von Marketingunterstützung, die Bereitstellung von Suchergebnissen und Links (einschließlich bezahlter Einträge und Links), die Bearbeitung von Kreditkartenzahlungen und die Bereitstellung von Kundendienst. Wir geben die persönlichen Daten unserer Nutzer an diese Beauftragten weiter, wenn wir dies für notwendig erachten, damit diese Dritten ihre Aufgaben erfüllen können.
                                </Typography>
                                <Typography variant="body1" gutterBottom data-sentry-element="Typography" data-sentry-source-file="page.jsx">
                                    <strong sx={{
                  fontFamily: "inherit"
                }}>
                                        Mitarbeitende.
                                    </strong>
                                    Nur autorisierte Mitarbeitende haben Zugang zu Ihren persönlichen Daten.
                                </Typography>
                                <Typography variant="body1" gutterBottom data-sentry-element="Typography" data-sentry-source-file="page.jsx">
                                    <strong sx={{
                  fontFamily: "inherit"
                }}>
                                        Verbundene Unternehmen.
                                    </strong>
                                    Wenn Sie während der Nutzung unseres Dienstes nach Informationen gefragt werden, geben Sie diese Informationen an uns und unsere verschiedenen Tochtergesellschaften weiter, sofern nicht ausdrücklich anders angegeben. Infolge dieser Weitergabe können Sie Mitteilungen von einem unserer verbundenen Unternehmen erhalten.
                                </Typography>
                                <Typography variant="body1" gutterBottom data-sentry-element="Typography" data-sentry-source-file="page.jsx">
                                    <strong sx={{
                  fontFamily: "inherit"
                }}>
                                        Verbundene Unternehmen und Tochtergesellschaften.
                                    </strong>
                                    Wir können personenbezogene Daten an unsere Tochtergesellschaften und verbundenen Unternehmen für Zwecke weitergeben, die mit dieser Datenschutzrichtlinie übereinstimmen.
                                </Typography>
                                <Typography variant="body1" gutterBottom data-sentry-element="Typography" data-sentry-source-file="page.jsx">
                                    <strong sx={{
                  fontFamily: "inherit"
                }}>
                                        Verbundene Unternehmen, die wir kontrollieren.
                                    </strong>
                                    Wir können Ihre personenbezogenen Daten an die von uns kontrollierten verbundenen Unternehmen weitergeben, um sicherzustellen, dass Ihre Erfahrung mit uns so nahtlos wie möglich ist und Sie den vollen Nutzen aus unseren Angeboten ziehen können. Die Verwendung Ihrer persönlichen Daten durch solche kontrollierten Tochtergesellschaften unterliegt weiterhin dieser Datenschutzrichtlinie.
                                </Typography>
                                <Typography variant="body1" gutterBottom data-sentry-element="Typography" data-sentry-source-file="page.jsx">
                                    <strong sx={{
                  fontFamily: "inherit"
                }}>
                                        Autorisierte Geschäftspartner.
                                    </strong>
                                    Dazu gehören Vertreter, Auftragnehmer, Verkäufer, Lizenzgeber, Wiederverkäufer, Systemintegratoren, etc. Softwaresupport Raab, unsere Tochtergesellschaften und unsere Geschäftspartner können diese personenbezogenen Daten untereinander austauschen und sie in Übereinstimmung mit dieser Datenschutzrichtlinie verwenden. Sie können diese Daten auch mit anderen Informationen kombinieren, um unsere Produkte, unseren Service, unsere Inhalte und unsere Werbung anzubieten und zu verbessern.
                                </Typography>
                                <Typography variant="body1" gutterBottom data-sentry-element="Typography" data-sentry-source-file="page.jsx">
                                    <strong sx={{
                  fontFamily: "inherit"
                }}>
                                        Autorisierte Dienstanbieter.
                                    </strong>
                                    . Ein autorisierter Serviceanbieter („ASP“) ist eine natürliche oder juristische Person, die berechtigt ist, Produkte zu warten, die noch durch Garantien einer anderen juristischen Person abgedeckt sind. Bei Serviceleistungen, die von anderen als einem autorisierten Serviceanbieter erbracht werden, erlischt in der Regel die Garantie. Wir können Informationen an solche ASPs weitergeben, um Dienstleistungen in unserem Namen zu erbringen. Wenn wir Ihre persönlichen Daten an diese Personen weitergeben, unterliegen sie Vereinbarungen, die diese Personen und Unternehmen verpflichten, Ihre persönlichen Daten nur auf unsere Anweisung und in Übereinstimmung mit dieser Datenschutzrichtlinie zu verarbeiten
                                </Typography>
                                <Typography variant="body1" gutterBottom data-sentry-element="Typography" data-sentry-source-file="page.jsx">
                                    <strong sx={{
                  fontFamily: "inherit"
                }}>
                                        Werbetreibende.
                                    </strong>
                                    Werbetreibende und Werbeplattformen von Drittanbietern können auch gezielte Werbung als Teil unseres Dienstes schalten. Weitere Informationen finden Sie in unserem Abschnitt über Werbung von Drittanbietern. Bitte beachten Sie, dass die Informationspraktiken von Drittanbietern oder Plattformen, die Daten über unseren Dienst sammeln, nicht von dieser Datenschutzrichtlinie abgedeckt werden.
                                </Typography>
                                <Typography variant="body1" gutterBottom data-sentry-element="Typography" data-sentry-source-file="page.jsx">
                                    <strong sx={{
                  fontFamily: "inherit"
                }}>
                                        Autorisierte Geschäftspartner, Werbetreibende, Agenten und Promotionsangebote
                                    </strong>
                                    Wir können Allianzen, Partnerschaften oder andere Geschäftsvereinbarungen mit Dritten eingehen, um personenbezogene Daten zu dem Zweck weiterzugeben, Ihnen Informationen über Produkte und Dienstleistungen zukommen zu lassen, von denen wir glauben, dass sie für Sie von Interesse sein könnten. Wir können Ihre Daten auch an dritte Partner weitergeben, damit diese ihre Produkte und Dienstleistungen besser auf ihre Kunden abstimmen können. Wenn Sie solche Angebote nicht erhalten möchten, setzen Sie sich bitte mit uns in Verbindung, wie in Abschnitt M (Ihre Rechte) unten beschrieben.
                                </Typography>
                                <Typography variant="body1" gutterBottom data-sentry-element="Typography" data-sentry-source-file="page.jsx">
                                    <strong sx={{
                  fontFamily: "inherit"
                }}>
                                        Andere Nutzer.
                                    </strong>
                                    Bitte denken Sie daran, dass alle Informationen, die Sie in öffentlichen Bereichen unseres Dienstes, wie z. B. in Message Boards oder Feedback-Abschnitten, weitergeben, öffentlich werden und jeder diese Informationen übernehmen und verwenden kann. Bitte seien Sie vorsichtig mit dem, was Sie in diesen Bereichen unseres Dienstes preisgeben, und veröffentlichen Sie keine persönlichen Daten, die Sie für sich behalten möchten. Wir empfehlen Ihnen dringend, keine persönlichen Daten in Ihrem Benutzernamen oder Passwort zu verwenden. Wenn Ihre persönlichen Daten in einem unserer Community-Foren veröffentlicht wurden, können Sie uns unter
                                    <Link href="mailto:support@descripio.com" style={{
                  color: "#AC1218",
                  textDecoration: "underline",
                  margin: "0 5px"
                }} data-sentry-element="Link" data-sentry-source-file="page.jsx">
                                        support@descirpio.com
                                    </Link>
                                    kontaktieren, um diese Informationen entfernen zu lassen.
                                </Typography>
                                <Typography variant="body1" gutterBottom data-sentry-element="Typography" data-sentry-source-file="page.jsx">
                                    <strong sx={{
                  fontFamily: "inherit"
                }}>
                                        Andere Einrichtungen.
                                    </strong>
                                    Wenn Sie uns personenbezogene Daten zur Veröffentlichung in Bereichen unseres Dienstes zur Verfügung stellen, die öffentlich einsehbar sind (z. B. Blogs oder Messaging-Funktionen), sind Ihre personenbezogenen Daten für Dritte, die unseren Dienst nutzen, zugänglich. Bitte seien Sie vorsichtig, wenn Sie die öffentlichen Funktionen unseres Dienstes nutzen.
                                </Typography>
                                <Typography variant="body1" gutterBottom data-sentry-element="Typography" data-sentry-source-file="page.jsx">
                                    <strong sx={{
                  fontFamily: "inherit"
                }}>
                                        Zur Einhaltung von rechtlichen Verfahren, zum Schutz von Softwaresupport Raab oder zur Durchsetzung unserer Rechte.
                                    </strong>
                                    Wir können Ihre persönlichen Daten freigeben, wenn dies notwendig ist, um (i) gesetzliche Anforderungen zu erfüllen oder einem Gerichtsverfahren nachzukommen; (ii) unsere Nutzungsbedingungen und andere Vereinbarungen durchzusetzen oder anzuwenden; (iii) die Rechte, die Sicherheit oder unser Eigentum, unseren Partnern, Dienstleistern, unseren Nutzern oder der Öffentlichkeit zu schützen; oder (iv) ein Verbrechen zu verhindern oder die nationale Sicherheit zu schützen (einschließlich des Austauschs von Informationen mit anderen Unternehmen und Organisationen zum Schutz vor Betrug und zur Reduzierung des Kreditrisikos).
                                </Typography>
                                <Typography variant="body1" gutterBottom data-sentry-element="Typography" data-sentry-source-file="page.jsx">
                                    <strong sx={{
                  fontFamily: "inherit"
                }}>
                                        Als Teil einer Fusion oder eines Geschäftsverkaufs.
                                    </strong>
                                    Wir können Ihre persönlichen Daten in Verbindung mit einer größeren Unternehmenstransaktion offenlegen, wie z. B. dem Verkauf unseres Unternehmens, einer Veräußerung, Fusion, Konsolidierung oder dem Verkauf von Vermögenswerten, oder im unwahrscheinlichen Fall eines konkurses.
                                    eines Konkurses
                                </Typography>


                            </Grid>
                            <Grid item xs={12} sx={{
              marginTop: "40px"
            }} data-sentry-element="Grid" data-sentry-source-file="page.jsx">
                                <Typography variant="h6" textAlign={"left"} sx={{
                color: "black",
                fontWeight: "800",
                fontSize: "20px"
              }} data-sentry-element="Typography" data-sentry-source-file="page.jsx">
                                    VII.	Verkauf von persönlichen Informationen
                                </Typography>
                                <Typography variant="h6" textAlign={"left"} sx={{
                color: "black",
                fontWeight: "500",
                fontSize: "16px",
                marginTop: "20px"
              }} data-sentry-element="Typography" data-sentry-source-file="page.jsx">
                                    Wir werden Ihre persönlichen Daten nicht ohne Ihre Zustimmung an Dritte zu deren Verwendung verkaufen.
                                </Typography>
                            </Grid>
                            <Grid item xs={12} sx={{
              marginTop: "40px"
            }} data-sentry-element="Grid" data-sentry-source-file="page.jsx">
                                <Typography variant="h6" textAlign={"left"} sx={{
                color: "black",
                fontWeight: "800",
                fontSize: "20px"
              }} data-sentry-element="Typography" data-sentry-source-file="page.jsx">
                                    VIII.	Datenschutz für Minderjährige und Kinder
                                </Typography>
                                <Box sx={{
                marginLeft: 3
              }} data-sentry-element="Box" data-sentry-source-file="page.jsx">
                                    <Typography variant="h6" textAlign={"left"} sx={{
                  color: "#AC1218",
                  fontWeight: "500",
                  fontSize: "16px",
                  marginTop: "20px"
                }} data-sentry-element="Typography" data-sentry-source-file="page.jsx">
                                        A.	Schutz von Kindern im Internet
                                    </Typography>
                                </Box>
                                <Typography variant="h6" textAlign={"left"} sx={{
                color: "black",
                fontWeight: "500",
                fontSize: "16px",
                marginTop: "20px"
              }} data-sentry-element="Typography" data-sentry-source-file="page.jsx">
                                    Unser Service richtet sich nicht an Kinder unter 16 Jahren. Wenn Sie nicht 16 Jahre oder älter sind, dürfen Sie unseren Service nicht nutzen. Wir sammeln nicht wissentlich persönliche Daten von Kindern unter 16 Jahren. Wenn wir erfahren, dass personenbezogene Daten von Personen unter 16 Jahren über unseren Dienst erfasst wurden, werden wir die entsprechenden Schritte unternehmen, um diese Informationen zu löschen. Wenn Sie ein Elternteil oder Erziehungsberechtigter sind und feststellen, dass Ihr Kind oder ein Minderjähriger unter 13 Jahren ohne Ihre Zustimmung personenbezogene Daten in unserem Dienst veröffentlicht, eingereicht oder anderweitig übermittelt hat, können Sie uns unter
                                    <span style={{
                  color: "#AC1218",
                  textDecoration: "underline",
                  margin: "0 5px"
                }}>
                                        office@raab.de.
                                    </span>
                                    benachrichtigen, damit wir geeignete Maßnahmen ergreifen können, um die personenbezogenen Daten des Minderjährigen aus unseren Systemen zu entfernen.
                                </Typography>
                                <Box sx={{
                marginLeft: 3
              }} data-sentry-element="Box" data-sentry-source-file="page.jsx">
                                    <Typography variant="h6" textAlign={"left"} sx={{
                  color: "#AC1218",
                  fontWeight: "500",
                  fontSize: "16px",
                  marginTop: "20px"
                }} data-sentry-element="Typography" data-sentry-source-file="page.jsx">
                                        B.	Löschung
                                    </Typography>
                                </Box>
                                <Typography variant="h6" textAlign={"left"} sx={{
                color: "black",
                fontWeight: "500",
                fontSize: "16px",
                marginTop: "20px"
              }} data-sentry-element="Typography" data-sentry-source-file="page.jsx">
                                    Unter bestimmten Umständen können Minderjährige unter 18 Jahren Inhalte und Informationen, die sie auf der Website oder in der App veröffentlichen, entfernen oder deren Entfernung beantragen und erhalten. Um solche Inhalte und Informationen zu entfernen oder deren Entfernung anzufordern und zu erhalten, muss der Nutzer uns unter
                                    <span style={{
                  color: "#AC1218",
                  textDecoration: "underline",
                  margin: "0 5px"
                }}>
                                        office@raab.de.
                                    </span>
                                    benachrichtigen. Nutzer sollten sich darüber im Klaren sein, dass die Entfernung der von Minderjährigen eingestellten Inhalte und Informationen keine vollständige oder umfassende Entfernung der auf unserem Service eingestellten Inhalte oder Informationen gewährleistet.
                                </Typography>
                                <Typography variant="h6" textAlign={"left"} sx={{
                color: "black",
                fontWeight: "500",
                fontSize: "16px",
                marginTop: "20px"
              }} data-sentry-element="Typography" data-sentry-source-file="page.jsx">
                                    Unter bestimmten Umständen sind wir nicht verpflichtet, die oben genannten Anforderungen zur Entfernung zu erfüllen. Wir behalten uns auch das Recht vor, soweit gesetzlich zulässig, die eingestellten Inhalte oder Informationen zu anonymisieren oder für andere Nutzer und die Öffentlichkeit unsichtbar zu machen, anstatt die Inhalte oder Informationen zu entfernen oder zu löschen.
                                </Typography>
                            </Grid>
                            <Grid item xs={12} sx={{
              marginTop: "40px"
            }} data-sentry-element="Grid" data-sentry-source-file="page.jsx">
                                <Typography variant="h6" textAlign={"left"} sx={{
                color: "black",
                fontWeight: "800",
                fontSize: "20px"
              }} data-sentry-element="Typography" data-sentry-source-file="page.jsx">
                                    IX.	Links zu Diensten Dritter
                                </Typography>
                                <Typography variant="h6" textAlign={"left"} sx={{
                color: "black",
                fontWeight: "500",
                fontSize: "16px",
                marginTop: "20px"
              }} data-sentry-element="Typography" data-sentry-source-file="page.jsx">
                                    Unser Service kann Links zu Websites, Anwendungen und Diensten von Dritten enthalten, die nicht von uns betrieben werden. Diese Links werden als Service zur Verfügung gestellt und bedeuten weder eine Billigung der Aktivitäten oder Inhalte dieser Websites, Anwendungen oder Dienste durch Softwaresupport Raab noch eine Verbindung mit deren Betreibern. Wir sind nicht verantwortlich für die Datenschutzrichtlinien von Dritten, einschließlich Websites oder Diensten, die Datenschutzrichtlinien von Dritten, einschließlich Websites oder Diensten, die direkt mit unserem Service verlinkt sind. Wir empfehlen Ihnen, die Datenschutzrichtlinien jeder Drittseite, die Sie von unserem Dienst aus verlinken, zu überprüfen.
                                </Typography>
                            </Grid>
                            <Grid item xs={12} sx={{
              marginTop: "40px"
            }} data-sentry-element="Grid" data-sentry-source-file="page.jsx">
                                <Typography variant="h6" textAlign={"left"} sx={{
                color: "black",
                fontWeight: "800",
                fontSize: "20px"
              }} data-sentry-element="Typography" data-sentry-source-file="page.jsx">
                                    X.	Soziale Medienfunktionen und Widgets
                                </Typography>
                                <Typography variant="h6" textAlign={"left"} sx={{
                color: "black",
                fontWeight: "500",
                fontSize: "16px",
                marginTop: "20px"
              }} data-sentry-element="Typography" data-sentry-source-file="page.jsx">
                                    Unser Dienst enthält Social-Media-Funktionen, wie z. B. die Facebook-Schaltfläche „Gefällt mir“ und Widgets, wie z. B. die Schaltfläche „Teilen“ oder die Authentifizierung Ihrer Identität durch Anmeldung bei unserem Dienst über ein Social-Media-Konto. Diese Funktionen können Ihre IP-Adresse erfassen, die Seite, die Sie auf unserem Dienst besuchen, und können ein Cookie setzen, damit die Funktion ordnungsgemäß funktioniert. Social-Media-Funktionen und -Widgets werden entweder von einem Drittanbieter gehostet oder direkt in unserem Dienst gehostet. Ihre Interaktion mit diesen Funktionen unterliegt den Datenschutzrichtlinien des Unternehmens, das sie bereitstellt.
                                </Typography>
                            </Grid>
                            <Grid item xs={12} sx={{
              marginTop: "40px"
            }} data-sentry-element="Grid" data-sentry-source-file="page.jsx">
                                <Typography variant="h6" textAlign={"left"} sx={{
                color: "black",
                fontWeight: "800",
                fontSize: "20px"
              }} data-sentry-element="Typography" data-sentry-source-file="page.jsx">
                                    XI.	Sicherheit und Aufbewahrung Ihrer Daten
                                </Typography>
                                <Typography variant="h6" textAlign={"left"} sx={{
                color: "black",
                fontWeight: "500",
                fontSize: "16px",
                marginTop: "20px"
              }} data-sentry-element="Typography" data-sentry-source-file="page.jsx">
                                    Wir setzen angemessene technische und organisatorische Maßnahmen ein, um Ihre personenbezogenen Daten vor unbefugtem Zugriff, Missbrauch, Verlust oder Zerstörung zu schützen. Ihre Daten werden nur so lange aufbewahrt, wie es für die Erfüllung der Zwecke erforderlich ist, für die sie erhoben wurden, oder solange gesetzliche Aufbewahrungsfristen bestehen.
                                </Typography>
                                <Box sx={{
                marginLeft: 3
              }} data-sentry-element="Box" data-sentry-source-file="page.jsx">
                                    <Typography variant="h6" textAlign={"left"} sx={{
                  color: "#AC1218",
                  fontWeight: "500",
                  fontSize: "16px",
                  marginTop: "20px"
                }} data-sentry-element="Typography" data-sentry-source-file="page.jsx">
                                        A.	Sicherheit
                                    </Typography>
                                </Box>
                                <Typography variant="h6" textAlign={"left"} sx={{
                color: "black",
                fontWeight: "500",
                fontSize: "16px",
                marginTop: "20px"
              }} data-sentry-element="Typography" data-sentry-source-file="page.jsx">
                                    Wir treffen angemessene technische und organisatorische Vorkehrungen, um die Vertraulichkeit, Sicherheit und Integrität Ihrer persönlichen Daten zu schützen. Obwohl wir Sicherheitsmaßnahmen ergreifen, um Ihre persönlichen Daten vor Verlust, Missbrauch oder unbefugter Offenlegung zu schützen, können wir die Sicherheit von Informationen, die über das Internet an uns übermittelt werden, nicht garantieren.
                                </Typography>
                                <Box sx={{
                marginLeft: 3
              }} data-sentry-element="Box" data-sentry-source-file="page.jsx">
                                    <Typography variant="h6" textAlign={"left"} sx={{
                  color: "#AC1218",
                  fontWeight: "500",
                  fontSize: "16px",
                  marginTop: "20px"
                }} data-sentry-element="Typography" data-sentry-source-file="page.jsx">
                                        B.	Speicherung
                                    </Typography>
                                </Box>
                                <Typography variant="h6" textAlign={"left"} sx={{
                color: "black",
                fontWeight: "500",
                fontSize: "16px",
                marginTop: "20px"
              }} data-sentry-element="Typography" data-sentry-source-file="page.jsx">
                                    Die persönlichen Daten, die Sie uns zur Verfügung stellen, werden im Allgemeinen auf Servern in der Europäischen Union gespeichert. Wenn Sie sich in einer anderen Gerichtsbarkeit befinden, sollten Sie sich darüber im Klaren sein, dass Ihre persönlichen Daten, sobald sie über unseren Service übermittelt werden, auf unsere Server in die Europäische Union übertragen werden und sich die Datenschutzvorgaben in Ihrem Land von denen der europäischen Union unterscheiden können.
                                </Typography>
                                <Box sx={{
                marginLeft: 3
              }} data-sentry-element="Box" data-sentry-source-file="page.jsx">
                                    <Typography variant="h6" textAlign={"left"} sx={{
                  color: "#AC1218",
                  fontWeight: "500",
                  fontSize: "16px",
                  marginTop: "20px"
                }} data-sentry-element="Typography" data-sentry-source-file="page.jsx">
                                        C.	Aufbewahrung
                                    </Typography>
                                </Box>
                                <Typography variant="h6" textAlign={"left"} sx={{
                color: "black",
                fontWeight: "500",
                fontSize: "16px",
                marginTop: "20px"
              }} data-sentry-element="Typography" data-sentry-source-file="page.jsx">
                                    Wir werden Ihre Daten so lange aufbewahren, wie es für die Bereitstellung des Dienstes erforderlich ist. Wenn Sie Ihr Konto kündigen oder verlangen, dass wir Ihre Daten nicht mehr für die Bereitstellung des Dienstes verwenden, kontaktieren Sie uns unter
                                    <Link href="mailto:support@descripio.com" style={{
                  color: "#AC1218",
                  textDecoration: "underline",
                  marginLeft: "5px"
                }} data-sentry-element="Link" data-sentry-source-file="page.jsx">
                                        support@descirpio.com
                                    </Link>
                                    Wir werden Ihre Daten aufbewahren und verwenden, soweit dies erforderlich ist, um unseren rechtlichen Verpflichtungen nachzukommen, Streitigkeiten beizulegen und unsere Vereinbarungen durchzusetzen.
                                </Typography>
                            </Grid>
                            <Grid item xs={12} sx={{
              marginTop: "40px"
            }} data-sentry-element="Grid" data-sentry-source-file="page.jsx">
                                <Typography variant="h6" textAlign={"left"} sx={{
                color: "black",
                fontWeight: "800",
                fontSize: "20px"
              }} data-sentry-element="Typography" data-sentry-source-file="page.jsx">
                                    XII.	Internationale Benutzer
                                </Typography>
                                <Box sx={{
                marginLeft: 3
              }} data-sentry-element="Box" data-sentry-source-file="page.jsx">
                                    <Typography variant="h6" textAlign={"left"} sx={{
                  color: "#AC1218",
                  fontWeight: "500",
                  fontSize: "16px",
                  marginTop: "20px"
                }} data-sentry-element="Typography" data-sentry-source-file="page.jsx">
                                        A.	Zustimmung zur Übertragung
                                    </Typography>
                                </Box>
                                <Typography variant="h6" textAlign={"left"} sx={{
                color: "black",
                fontWeight: "500",
                fontSize: "16px",
                marginTop: "20px"
              }} data-sentry-element="Typography" data-sentry-source-file="page.jsx">
                                    Wir haben unseren Hauptsitz in Deutschland (Europäische Union). Ihre personenbezogenen Daten können von uns abgerufen oder an uns übermittelt werden. Wenn Sie unseren Dienst von außerhalb der Europäischen Union besuchen, sollten Sie sich bewusst sein, dass Ihre Daten in die Europäische Union übertragen, dort gespeichert und verarbeitet werden können, wo sich unsere Server befinden und unsere zentrale Datenbank betrieben wird. Durch die Nutzung unseres Dienstes erklären Sie sich mit der Übertragung dieser Informationen einverstanden.
                                </Typography>
                                <Typography variant="h6" textAlign={"left"} sx={{
                color: "black",
                fontWeight: "500",
                fontSize: "16px",
                marginTop: "20px"
              }} data-sentry-element="Typography" data-sentry-source-file="page.jsx">
                                    Sie erkennen jedoch ausdrücklich an und stimmen zu, dass in der Europäischen Union gespeicherte oder verarbeitete personenbezogene Daten den Gesetzen der Europäischen Union (insbesondere Deutschland) unterliegen, einschließlich der Möglichkeit von Regierungen, Gerichten oder Strafverfolgungs- oder Aufsichtsbehörden der Europäischen Union (insbesondere Deutschland), die Offenlegung Ihrer personenbezogenen Daten zu verlangen.
                                </Typography>
                            </Grid>
                            <Grid item xs={12} sx={{
              marginTop: "40px"
            }} data-sentry-element="Grid" data-sentry-source-file="page.jsx">
                                <Typography variant="h6" textAlign={"left"} sx={{
                color: "black",
                fontWeight: "800",
                fontSize: "20px"
              }} data-sentry-element="Typography" data-sentry-source-file="page.jsx">
                                    XIII.	Hinweis zur Datenweitergabe in die USA
                                </Typography>
                                <Typography variant="h6" textAlign={"left"} sx={{
                color: "black",
                fontWeight: "500",
                fontSize: "16px",
                marginTop: "20px"
              }} data-sentry-element="Typography" data-sentry-source-file="page.jsx">
                                    Auf unserer Website verwenden wir Tools von Anbietern, die in den USA ansässig sind (z.B. Google Analytics). Wenn diese Tools aktiv sind, können Ihre personenbezogenen Daten an Server in den USA übermittelt werden. Wir weisen darauf hin, dass die USA aus Sicht der EU kein sicheres Drittland im Sinne des Datenschutzes sind. US-Unternehmen sind gesetzlich verpflichtet, personenbezogene Daten an Sicherheitsbehörden weiterzugeben, ohne dass Sie als Betroffener rechtlich dagegen vorgehen können.
                                </Typography>
                            </Grid>
                            <Grid item xs={12} sx={{
              marginTop: "40px"
            }} data-sentry-element="Grid" data-sentry-source-file="page.jsx">
                                <Typography variant="h6" textAlign={"left"} sx={{
                color: "black",
                fontWeight: "800",
                fontSize: "20px"
              }} data-sentry-element="Typography" data-sentry-source-file="page.jsx">
                                    XIV.	Rechte der betroffenen Personen</Typography>
                                <Typography variant="h6" textAlign={"left"} sx={{
                color: "black",
                fontWeight: "500",
                fontSize: "16px",
                marginTop: "20px"
              }} data-sentry-element="Typography" data-sentry-source-file="page.jsx">
                                    Sie haben gemäß der DSGVO verschiedene Rechte in Bezug auf Ihre personenbezogenen Daten. Diese umfassen insbesondere:
                                </Typography>
                                <Box component="ol" sx={{
                marginLeft: 3
              }} data-sentry-element="Box" data-sentry-source-file="page.jsx">
                                    <Typography component="li" variant="body1" gutterBottom data-sentry-element="Typography" data-sentry-source-file="page.jsx">
                                        -	Recht auf Auskunft (Art. 15 DSGVO): Sie können Auskunft über die von uns verarbeiteten personenbezogenen Daten verlangen.
                                    </Typography>
                                    <Typography component="li" variant="body1" gutterBottom data-sentry-element="Typography" data-sentry-source-file="page.jsx">
                                        -	Recht auf Berichtigung (Art. 16 DSGVO): Sie können die Berichtigung unrichtiger oder unvollständiger Daten verlangen.
                                    </Typography>
                                    <Typography component="li" variant="body1" gutterBottom data-sentry-element="Typography" data-sentry-source-file="page.jsx">
                                        -	Recht auf Löschung (Art. 17 DSGVO): Sie können die Löschung Ihrer Daten verlangen, sofern keine gesetzlichen Aufbewahrungspflichten bestehen.
                                    </Typography>
                                    <Typography component="li" variant="body1" gutterBottom data-sentry-element="Typography" data-sentry-source-file="page.jsx">
                                        -	Recht auf Einschränkung der Verarbeitung (Art. 18 DSGVO)
                                    </Typography>
                                </Box>
                                <Typography variant="h6" textAlign={"left"} sx={{
                color: "black",
                fontWeight: "500",
                fontSize: "16px",
                marginTop: "20px"
              }} data-sentry-element="Typography" data-sentry-source-file="page.jsx">
                                    Sie können zudem die Einschränkung der Verarbeitung Ihrer Daten verlangen, unter anderem gem.:
                                </Typography>
                                <Box component="ol" sx={{
                marginLeft: 3
              }} data-sentry-element="Box" data-sentry-source-file="page.jsx">
                                    <Typography component="li" variant="body1" gutterBottom data-sentry-element="Typography" data-sentry-source-file="page.jsx">
                                        -	Recht auf Widerspruch gegen die Verarbeitung (Art. 21 DSGVO): Sie haben das Recht, der Verarbeitung Ihrer Daten zu widersprechen.
                                    </Typography>
                                    <Typography component="li" variant="body1" gutterBottom data-sentry-element="Typography" data-sentry-source-file="page.jsx">
                                        -	Recht auf Datenübertragbarkeit (Art. 20 DSGVO): Sie können die Übertragung Ihrer Daten in einem maschinenlesbaren Format verlangen.
                                    </Typography>
                                    <Typography component="li" variant="body1" gutterBottom data-sentry-element="Typography" data-sentry-source-file="page.jsx">
                                        -	Recht auf Widerruf der Einwilligung (Art. 7 Abs. 3 DSGVO): Sie können Ihre Einwilligung jederzeit widerrufen.
                                    </Typography>
                                    <Typography component="li" variant="body1" gutterBottom data-sentry-element="Typography" data-sentry-source-file="page.jsx">
                                        -	Recht auf Einschränkung der Verarbeitung (Art. 18 DSGVO)
                                    </Typography>
                                </Box>
                                <Typography variant="h6" textAlign={"left"} sx={{
                color: "black",
                fontWeight: "500",
                fontSize: "16px",
                marginTop: "20px"
              }} data-sentry-element="Typography" data-sentry-source-file="page.jsx">
                                    <strong>Hierzu können Sie sich jederzeit via
                                        <Link href="mailto:support@descripio.com" style={{
                    color: "#AC1218",
                    textDecoration: "underline",
                    margin: "0 5px"
                  }} data-sentry-element="Link" data-sentry-source-file="page.jsx">
                                            support@descirpio.com
                                        </Link>
                                        an uns wenden.</strong>
                                </Typography>
                                <Typography variant="h6" textAlign={"left"} sx={{
                color: "black",
                fontWeight: "500",
                fontSize: "16px",
                marginTop: "20px"
              }} data-sentry-element="Typography" data-sentry-source-file="page.jsx">
                                    Wenn Sie die Richtigkeit Ihrer bei uns gespeicherten personenbezogenen Daten bestreiten, benötigen wir in der Regel Zeit, um dies zu überprüfen. Für die Dauer der Prüfung haben Sie das Recht, die Einschränkung der Verarbeitung Ihrer personenbezogenen Daten zu verlangen.
                                </Typography>
                                <Typography variant="h6" textAlign={"left"} sx={{
                color: "black",
                fontWeight: "500",
                fontSize: "16px",
                marginTop: "20px"
              }} data-sentry-element="Typography" data-sentry-source-file="page.jsx">
                                    Wenn die Verarbeitung Ihrer personenbezogenen Daten unrechtmäßig geschah/geschieht, können Sie statt der Löschung die Einschränkung der Datenverarbeitung verlangen.
                                </Typography>
                                <Typography variant="h6" textAlign={"left"} sx={{
                color: "black",
                fontWeight: "500",
                fontSize: "16px",
                marginTop: "20px"
              }} data-sentry-element="Typography" data-sentry-source-file="page.jsx">
                                    Wenn wir Ihre personenbezogenen Daten nicht mehr benötigen, Sie sie jedoch zur Ausübung, Verteidigung oder Geltendmachung von Rechtsansprüchen benötigen, haben Sie das Recht, statt der Löschung die Einschränkung der Verarbeitung Ihrer personenbezogenen Daten zu verlangen.
                                </Typography>
                                <Typography variant="h6" textAlign={"left"} sx={{
                color: "black",
                fontWeight: "500",
                fontSize: "16px",
                marginTop: "20px"
              }} data-sentry-element="Typography" data-sentry-source-file="page.jsx">
                                    Wenn Sie einen Widerspruch nach Art. 21 Abs. 1 DSGVO eingelegt haben, muss eine Abwägung zwischen Ihren und unseren Interessen vorgenommen werden. Solange noch nicht feststeht, wessen Interessen überwiegen, haben Sie das Recht, die Einschränkung der Verarbeitung Ihrer personenbezogenen Daten zu verlangen.
                                </Typography>
                                <Typography variant="h6" textAlign={"left"} sx={{
                color: "black",
                fontWeight: "500",
                fontSize: "16px",
                marginTop: "20px"
              }} data-sentry-element="Typography" data-sentry-source-file="page.jsx">
                                    Wenn Sie die Verarbeitung Ihrer personenbezogenen Daten eingeschränkt haben, dürfen diese Daten – von ihrer Speicherung abgesehen – nur mit Ihrer Einwilligung oder zur Geltendmachung, Ausübung oder Verteidigung von Rechtsansprüchen oder zum Schutz der Rechte einer anderen natürlichen oder juristischen Person oder aus Gründen eines wichtigen öffentlichen Interesses der Europäischen Union oder eines Mitgliedstaats verarbeitet werden.
                                </Typography>
                            </Grid>
                            <Grid item xs={12} sx={{
              marginTop: "40px"
            }} data-sentry-element="Grid" data-sentry-source-file="page.jsx">
                                <Typography variant="h6" textAlign={"left"} sx={{
                color: "black",
                fontWeight: "800",
                fontSize: "20px"
              }} data-sentry-element="Typography" data-sentry-source-file="page.jsx">
                                    XV.	Änderungen an dieser Datenschutzrichtlinie
                                </Typography>
                                <Typography variant="h6" textAlign={"left"} sx={{
                color: "black",
                fontWeight: "500",
                fontSize: "16px",
                marginTop: "20px"
              }} data-sentry-element="Typography" data-sentry-source-file="page.jsx">
                                    Wir behalten uns das Recht vor, diese Datenschutzrichtlinie von Zeit zu Zeit zu aktualisieren oder zu ändern. Wenn wir wesentliche Änderungen an dieser Datenschutzrichtlinie oder an der Art und Weise, wie wir personenbezogene Daten verwenden, weitergeben oder sammeln, vornehmen, werden wir Sie benachrichtigen, indem wir das „Datum des Inkrafttretens“ oben in dieser Datenschutzrichtlinie ändern, eine Ankündigung der Änderungen deutlich sichtbar in unserem Service veröffentlichen oder eine E-Mail an die E-Mail-Adresse senden, die Sie uns zuletzt zur Verfügung gestellt haben (es sei denn, wir haben keine solche E-Mail-Adresse), bevor die neue Richtlinie in Kraft tritt. Die Benutzer sind an alle Änderungen der Datenschutzrichtlinie gebunden, wenn sie unseren Service nach der Bekanntgabe solcher Änderungen nutzen. Wir empfehlen Ihnen, diese Datenschutzrichtlinie regelmäßig zu lesen, um sicherzustellen, dass Sie mit den aktuellen Praktiken von Softwaresupport Raab vertraut sind.
                                </Typography>
                            </Grid>
                            <Grid item xs={12} sx={{
              marginTop: "40px"
            }} data-sentry-element="Grid" data-sentry-source-file="page.jsx">
                                <Typography variant="h6" textAlign={"left"} sx={{
                color: "black",
                fontWeight: "800",
                fontSize: "20px"
              }} data-sentry-element="Typography" data-sentry-source-file="page.jsx">
                                    XVI.	Kontakt
                                </Typography>
                                <Typography variant="h6" textAlign={"left"} sx={{
                color: "black",
                fontWeight: "500",
                fontSize: "16px",
                marginTop: "20px"
              }} data-sentry-element="Typography" data-sentry-source-file="page.jsx">
                                    Wenn Sie Fragen zu dieser Datenschutzerklärung haben oder Ihre Rechte ausüben möchten, kontaktieren Sie uns bitte:
                                </Typography>
                                <Typography variant="h6" textAlign={"left"} sx={{
                color: "black",
                fontWeight: "700",
                fontSize: "16px",
                marginTop: "20px"
              }} data-sentry-element="Typography" data-sentry-source-file="page.jsx">
                                    Softwaresupport Raab GmbH
                                </Typography>
                                <Typography variant="h6" textAlign={"left"} sx={{
                color: "black",
                fontWeight: "700",
                fontSize: "16px"
              }} data-sentry-element="Typography" data-sentry-source-file="page.jsx">
                                    Schießäckerstraße 24
                                </Typography>
                                <Typography variant="h6" textAlign={"left"} sx={{
                color: "black",
                fontWeight: "700",
                fontSize: "16px"
              }} data-sentry-element="Typography" data-sentry-source-file="page.jsx">
                                    91083 Baiersdorf
                                </Typography>
                                <Typography variant="h6" textAlign={"left"} sx={{
                color: "black",
                fontWeight: "700",
                fontSize: "16px"
              }} data-sentry-element="Typography" data-sentry-source-file="page.jsx">
                                    E-Mail: office@raab.de oder <Link href="mailto:support@descripio.com" style={{
                  color: "#AC1218",
                  textDecoration: "underline",
                  marginLeft: "5px"
                }} data-sentry-element="Link" data-sentry-source-file="page.jsx">
                                        support@descirpio.com
                                    </Link>
                                </Typography>
                            </Grid>
                            <Grid item xs={12} data-sentry-element="Grid" data-sentry-source-file="page.jsx">
                                <Link href="/signup" data-sentry-element="Link" data-sentry-source-file="page.jsx">
                                    <Button width={"100%"} sx={{
                  bgcolor: "#AC1218",
                  color: "white",
                  borderRadius: "8px",
                  border: "1px solid #AC1218",
                  textTransform: "capitalize",
                  padding: "5px 20px 5px 10px",
                  textWrap: "nowrap",
                  fontSize: {
                    sm: "14px"
                  },
                  lineHeight: "24px",
                  fontWeight: "600",
                  marginBottom: "10px",
                  marginTop: "20px",
                  width: {
                    xs: "100%",
                    sm: "auto"
                  },
                  cursor: "pointer",
                  "&:hover": {
                    bgcolor: "white",
                    color: "#AC1218",
                    border: "1px solid #AC1218"
                  }
                }} data-sentry-element="Button" data-sentry-source-file="page.jsx">  <ReplyIcon sx={{
                    color: "inherit",
                    marginRight: "5px"
                  }} data-sentry-element="ReplyIcon" data-sentry-source-file="page.jsx" />
                                        Back
                                    </Button>
                                </Link>
                            </Grid>
                        </Grid>
                    </Box>
                </Box>
                <CrispChat data-sentry-element="CrispChat" data-sentry-source-file="page.jsx" />
            </ThemeProvider>
        </Wrapper>;
};
export default DataProtection;